import React from 'react';
import { CheckCircle2, Trash2 } from 'lucide-react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { StatusBadge } from './StatusBadge';
import { visitTypes, getVisitTypeColor } from './schedulingConstants';

export function VisitDetailModal({ entry, isOpen, onClose, onUpdateStatus, onDelete }) {
  if (!entry) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Visit Details</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <Badge className={getVisitTypeColor(entry.visit_type)}>
              {visitTypes.find(t => t.id === entry.visit_type)?.name}
            </Badge>
            <StatusBadge status={entry.status} />
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-slate-500">Client</p>
              <p className="font-medium">{entry.client_name}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Care Worker</p>
              <p className="font-medium">{entry.staff_name}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Date</p>
              <p className="font-medium">{entry.scheduled_date}</p>
            </div>
            <div>
              <p className="text-sm text-slate-500">Time</p>
              <p className="font-medium">{entry.start_time} - {entry.end_time}</p>
            </div>
          </div>

          {entry.tasks?.length > 0 && (
            <div>
              <p className="text-sm text-slate-500 mb-2">Tasks</p>
              <div className="flex flex-wrap gap-1">
                {entry.tasks.map((task, i) => (
                  <Badge key={i} variant="outline">{task}</Badge>
                ))}
              </div>
            </div>
          )}

          {entry.notes && (
            <div>
              <p className="text-sm text-slate-500">Notes</p>
              <p className="text-sm">{entry.notes}</p>
            </div>
          )}

          <div className="flex gap-2 pt-4 border-t">
            {entry.status === 'scheduled' && (
              <>
                <Button size="sm" onClick={() => onUpdateStatus(entry.id, 'in_progress')}>
                  Start Visit
                </Button>
                <Button size="sm" variant="outline" onClick={() => onUpdateStatus(entry.id, 'cancelled')}>
                  Cancel
                </Button>
              </>
            )}
            {entry.status === 'in_progress' && (
              <Button size="sm" className="bg-green-600 hover:bg-green-700" onClick={() => onUpdateStatus(entry.id, 'completed')}>
                <CheckCircle2 className="w-4 h-4 mr-1" /> Complete
              </Button>
            )}
            <Button size="sm" variant="destructive" onClick={() => { onDelete(entry.id); onClose(); }}>
              <Trash2 className="w-4 h-4 mr-1" /> Delete
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
